
require('./myGlobalPositionView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const { withRouter, Link } = require('react-router-dom');
const PropTypes = require('prop-types');
const classnames = require('classnames');
// @assets
import bannerImage from 'assets/images/cards/easyLoanBanner.png';
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ utils
const {
    conditionalClassName,
    contactCenterClassName,
} = require('utilities/conditionals/conditionalClassname');
const { getFormattedString } = require('utilities/currencyHelper');
const {
    recordLinkV2,
    recordLink,
    PROC_GLOBAL_POSITION,
    EVENT_REQUEST_EASY_LOAN,
    START_ZONE_PG_SUPERIOR,
    START_ZONE_PG_CENTRAL,
} = require('utilities/tagging');
const DateHelper = require('utilities/dateHelper');
const UrlHelper = require('utilities/urlHelper');
const { changeBiocatchContext } = require('utilities/biocatch');

// @actions
const expensesActionsOld = require('actions/globalPositionExpensesOld');
const { requestPublicInformation, setWaferIdRequest } = require('actions/myGlobalPosition');
const accessKeyChangeActions = require('actions/accessKeyChange');
const userNotificationsActions = require('actions/userNotifications');
const aggregatorDataActions = require('actions/aggregator/aggregatorData');
const fatcaDocumentarionActions = require('actions/fatcaDocumentation');
const { okLoanActions } = require('ok-loans');
const personeticsSubscriptionActions = require('actions/personeticsSubscription');
import { getGlobalPositionTink } from 'actions/aggregator/aggregatorData';
import AggregatorCommercialAdd from 'components/aggregator/aggregatorCommercialAdd/aggregatorCommercialAdd';
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @components
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const GlobalPositionExpenses = require('components/globalPosition/globalPositionExpenses/globalPositionExpenses');
const ExpensesSummaryBox = require('components/expensesSummaryBox/expensesSummaryBox');
const GlobalPositionSavingsSection = require('components/globalPosition/globalPositionSavingsSection/globalPositionSavingsSection');
const GlobalPositionInvestmentsSection = require('components/globalPosition/globalPositionInvestmentsSection/globalPositionInvestmentsSection');
const GlobalPositionFinancialSection = require('components/globalPosition/globalPositionFinancialSection/globalPositionFinancialSection');
const GlobalAllPositionsSummary = require('components/globalPosition/globalAllPositionsSummary/globalAllPositionsSummary');
const AggregatorResume = require('components/aggregator/aggregatorResume/aggregatorResume');
const { AggregatorSummary } = require('components/aggregator/aggregatorSummary/aggregatorSummary');
const ProspectPrompt = require('components/prospectPrompt/prospectPrompt');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const {
    PersoneticsTeasersView,
} = require('components/personetics/personeticsTeaser/personeticsTeaser');
import { OKButton } from 'commonsComponents/OKButton';

// hocs
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';
import { SET_ID } from "constants/tagging";
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { wafferShowConditions } from '../../utilities/myGlobalPosition/wafferConditions';

// @commons
const LastAccess = !__CONTACT_CENTER__
    ? require('components/lastAccess/lastAccess')
    : require('components/contactCenter/lastAccesContactCenter/lastAccesContactCenter');
const { OKCover } = require('commonsComponents/OKCover');
const { OKMessage } = require('commonsComponents/OKMessage');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { ECommerceKeyBanner } = require('components/eCommerceKeyBanner/eCommerceKeyBanner');
const {
    CommercialAdsCCValidated: CommercialAds,
} = require('components/commons/commercialAds/commercialAds');
const { OKIconTask } = require('commonsComponents/OKIconTask');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { isAggregatorEnabled } = require('utilities/aggregator/aggregatorToggleHelper');

// @constants
const { GRAPHIC_TUTOR_TYPE_1, GRAPHIC_TUTOR_TYPE_13, TWO_DECIMALS, CREDIT_CARD_STANDAR_TYPE } = require('constants/index');
const {
    AGGREGATOR,
    CREDIT,
    ECOMMERCE_KEY,
    INVESTMENTS,
    PFM,
    PFM_NEW_FEATURES,
    FISCAL_MESSAGE,
    SCA_BANNER,
    EASY_LOAN_WAFFER,
    NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES
} = require('constants/flagBasedFeatures');
const fatcaPath = '/myprofile/fatca';
const biocatch = require('constants/biocatch');
import { API_MIGRATION_STATE } from '../migrationUsersBranchView/migrationUsersBranchView.constants';
import { hasBannerForMigration, isFlowMigrationAllowed, isItWebViewPlatform } from '../migrationUsersBranchView/utilities/migration.utils';

class MyGlobalPositionView extends React.Component {
    constructor(props) {
        super(props);
        this.addMessageEventListener = this.addMessageEventListener.bind(this);

        this.state = {
            fiscalMessageVisible: true,
            scaMessageVisible: true,
            migrationMessageVisible: true,
            isTrackingSent: false,
        };
        this.fiscalMessage = null;
        this.scaMessage = null;
        this.linksAddedFiscalMessage = false;
        this.linksAddedScaMessage = false;
    }

    componentDidMount() {
        const {
            immEasyLoan,
            immEasyLoanTypeC,
            immSegmentedLoanProducts,
            getSegmentedLoanProducts,
            requestAccessKeyData,
            location: { hash },
            flagBasedFeatures,
            getEntitiesData,
            getGlobalPositionTink,
            isTinkAggregator,
            customerId
        } = this.props;
        recordLinkV2({
            tealium_event: SET_ID,
            customerId: customerId
        })

        if (
            flagBasedFeatures.get('hasBeenFetched') &&
            !flagBasedFeatures.get('hasError') &&
            flagBasedFeatures.get(AGGREGATOR) &&
            !__CONTACT_CENTER__
        ) {
            return isTinkAggregator ? getGlobalPositionTink() : getEntitiesData();
        }

        requestAccessKeyData();
        if (hash && hash === '#pg-other-banks') {
            const pgo = document.getElementById('pg-other-banks');
            window.scrollTo(0, pgo.offsetParent.offsetTop + pgo.offsetTop);
        }

        if (!this.linksAddedFiscalMessage && this.fiscalMessage) {
            this.addMessageEventListener(this.fiscalMessage);
            this.linksAddedFiscalMessage = true;
        }

        if (!this.linksAddedScaMessage && this.scaMessage) {
            this.addMessageEventListener(this.scaMessage);
            this.linksAddedScaMessage = true;
        }

        if (!immSegmentedLoanProducts.get('isFetching') && (!immEasyLoan.get('stepReady') || !immEasyLoanTypeC.get('stepReady'))) {
            getSegmentedLoanProducts();
        }
        setWaferIdRequest('');
    }

    addMessageEventListener(message) {
        const links = message.querySelectorAll('a');

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            const url = link.getAttribute('href');
            link.addEventListener('click', e => {
                e.preventDefault();
                this.props.history.push(url);
            });
        }
    }

    goToEdit() {
        this.props.history.push(fatcaPath);
        this.closeModal();
    }

    buildSettingsMobileButton() {
        const targetElement = (
            <OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />
        );
        const moreOptions = [
            {
                link: `/myprofile/settings`,
                text: formatText('profileNavBar-PGSettings'),
            },
        ];
        return (
            <div className="global-position__settings-mobile-menu">
                <PopoverMenu target={targetElement} items={moreOptions} placement="bottomRight" />
            </div>
        );
    }

    buildEasyLoanInfo() {
        const { immEasyLoan, immEasyLoanTypeC, immPayrollLoanRecordStatus } = this.props;
        const stepReady = immEasyLoanTypeC.get('showTypeC') ? immEasyLoanTypeC.get('stepReady') : immEasyLoan.get('stepReady');
        const easyLoan = immEasyLoanTypeC.get('showTypeC') ? immEasyLoanTypeC : immEasyLoan;
        const subtype = immEasyLoan.get('subtype')
        let result = null;
        const status = immPayrollLoanRecordStatus.get('state');

        if (stepReady && wafferShowConditions(status)) {
            const installment = {
                amount: easyLoan.get('maxAmount'),
                currency: easyLoan.get('currency'),
                decimalsLength: TWO_DECIMALS,
            };
            const formattedAmount = getFormattedString(installment);

            result = {
                title: formatText('contractEasyLoan-contractEasyLoan_finantialSectionLink', [
                    formattedAmount,
                ]).toUpperCase(),
                button: formatText('rightsSelector-linkBox'),
                installment,
                formattedAmount,
                link: '/myprofile/loans-mortgages/contract-easy-loan',
                currency: easyLoan.get('currency'),
                onTopClick: () =>
                    recordLink('espacio comercial prestamo preaprobado', 'click', 'solicitar'),
                onClick: () =>
                    recordLink(PROC_GLOBAL_POSITION, EVENT_REQUEST_EASY_LOAN, '', START_ZONE_PG_CENTRAL),
            };
        }

        return result;
    }

    buildEasyLoanSideAccess(easyLoanInfo) {
        const { clientName } = this.props;
        return (
            <div className={__CONTACT_CENTER__ && 'grid-view--fix-cell-separation'}>
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation my-global-position-view__loan-side-view">
                    <Link
                        onClick={() => easyLoanInfo.onTopClick()}
                        to={easyLoanInfo.link}
                        className="my-global-position-view__easy-loan-link-container"
                    >
                        <div className="my-global-position-view__easy-loan-access">
                            <div className="col-md-8 my-global-position-view__easy-loan-container-info">
                                <div className="my-global-position-view__container-content">
                                    <img src={bannerImage}></img>

                                    <div className="my-global-position-view__easy-loan-container-text">
                                        <div>
                                            <span className="my-global-position-view__easy-loan-name-client">
                                                {clientName.trim()}
                                            </span>
                                            <FormattedText
                                                className="my-global-position-view__easy-loan-text"
                                                value="contractEasyLoan-contractEasyLoan_available"
                                            />
                                            <div className="my-global-position-view__easy-loan-value">
                                                {easyLoanInfo.formattedAmount}
                                            </div>
                                        </div>
                                        <div className="my-global-position-view__easy-loan-button-container">
                                            <OKButton modifier="primary" onClick={''} size="small">
                                                {easyLoanInfo.button}
                                            </OKButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        );
    }


    buildCardSideAccess() {
        const { clientName } = this.props;
        const linkButton = formatText('rightsSelector-linkBox')
        const link = formatText('preapprovedCardWaffer-contractCardLink_available')
        return (
            <div className={__CONTACT_CENTER__ && "grid-view--fix-cell-separation"}>
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation my-global-position-view__loan-side-view">
                    <div className="my-global-position-view__easy-card-access">
                        <div className="col-md-8 my-global-position-view__container-info">
                            <span className="my-global-position-view__easy-loan-name-client">
                                {clientName.trim()}
                            </span>
                            <FormattedText
                                className="my-global-position-view__easy-card-text"
                                value="preapprovedCardWaffer-contractCardText_available"
                            />
                        </div>
                        <div className="col-md-3 my-global-position-view__container-request-button">
                            <div className="my-global-position-view__easy-loan-link">
                                <a href={link} className="my-global-position-view__easy-loan-link">{linkButton}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    buildFiscalMessage = () => {
        const { flagBasedFeatures } = this.props;
        const { fiscalMessageVisible } = this.state;
        const onCloseButtonClick = () => this.setState({ fiscalMessageVisible: false });
        const topLevelDomain = UrlHelper.getTopLevelDomain();
        const currentYear = DateHelper.getFullYear(DateHelper.todayDate());

        const showFiscalMessage = () => {
            const fiscalMessageDatesByDomain = {
                es: {
                    start: `${currentYear}-04-11`,
                    end: `${currentYear}-06-30`,
                },
                de: {
                    start: `${currentYear}-04-30`,
                    end: `${currentYear}-07-31`,
                },
                pt: {
                    start: `${currentYear}-03-30`,
                    end: `${currentYear}-04-30`,
                },
                nl: {
                    start: `${currentYear}-03-01`,
                    end: `${currentYear}-03-31`,
                },
            };

            const { start, end } =
                fiscalMessageDatesByDomain[topLevelDomain] || fiscalMessageDatesByDomain['es'];

            return (
                DateHelper.isTodayBetween(start, end) &&
                flagBasedFeatures.get(FISCAL_MESSAGE) &&
                !(flagBasedFeatures.get(SCA_BANNER) && flagBasedFeatures.get(ECOMMERCE_KEY)) &&
                !__CONTACT_CENTER__
            );
        };

        if (showFiscalMessage()) {
            return (
                <div className="col-xs-12 col-md-12">
                    <div
                        className="my-global-position-view__fiscal-message"
                        ref={ref => (this.fiscalMessage = ref)}
                    >
                        <OKMessage
                            key="fiscalMessage"
                            closeButton={true}
                            id="fiscalMessage"
                            modifier="dark-bg"
                            onCloseButtonClick={onCloseButtonClick}
                            visible={fiscalMessageVisible}
                        >
                            <FormattedText value="globalPosition-fiscalMessage" />
                        </OKMessage>
                    </div>
                </div>
            );
        }
    };

    buildSCAMessage = () => {
        const { flagBasedFeatures } = this.props;
        const { scaMessageVisible } = this.state;
        const onCloseButtonClick = () => this.setState({ scaMessageVisible: false });
        const showSCAMessage =
            flagBasedFeatures.get(SCA_BANNER) &&
            flagBasedFeatures.get(ECOMMERCE_KEY) &&
            !__CONTACT_CENTER__;

        let scaMessage;

        if (showSCAMessage) {
            scaMessage = (
                <div className="col-xs-12 col-md-12">
                    <div
                        className="my-global-position-view__sca-message"
                        ref={ref => (this.scaMessage = ref)}
                    >
                        <OKMessage
                            key="scaMessage"
                            closeButton={true}
                            id="scaMessage"
                            modifier="dark-bg"
                            onCloseButtonClick={onCloseButtonClick}
                            visible={scaMessageVisible}
                        >
                            <FormattedText value="globalPosition-globalPosition_scaMessage" />
                        </OKMessage>
                    </div>
                </div>
            );
        }

        return scaMessage;
    };

    buildMigrationMessage = () => {
        const { immMigration, immProfile } = this.props;

        const goToMigration = () => {
            recordLinkV2({
                categoriaEvento: "mensaje migracion",
                accionEvento: "migrar ahora",
                action: "click",
                format: "button",
                component: "message/migration",
                element: "migrateNow"
            })
            this.props.history.push('/myprofile/migration');
        };

        const showMigrationMessage = immProfile.get('originCountry')
            && immProfile.get('originCountry') === 'DE'
            && immMigration.getIn(['fetched'])
            && immMigration.getIn(['status'])
            && hasBannerForMigration(immMigration.getIn(['status']))
            && !__CONTACT_CENTER__
            && this.state.migrationMessageVisible;

        if (showMigrationMessage) {
            if (
                isItWebViewPlatform()
                && isFlowMigrationAllowed(immMigration.getIn(['status']))
            ) {
                this.props.history.push('/myprofile/migration');
                return null;
            }
            const isCompleted = immMigration.getIn(['status']) === API_MIGRATION_STATE.VIDEOCALL_SUCCESS;
            const onCloseButtonClick = () => {
                recordLinkV2(isCompleted ? {
                    categoriaEvento: "mensaje migracion completada",
                    accionEvento: "cerrar",
                    action: "close",
                    format: "cross",
                    component: "message/migrationCompleted",
                    element: "cross"
                } : {
                    categoriaEvento: "mensaje migracion",
                    accionEvento: "cerrar",
                    action: "close",
                    format: "cross",
                    component: "message/migration",
                    element: "cross"
                });
                this.setState({ migrationMessageVisible: false });
            };
            if (this.state.isTrackingSent === false) {
                recordLinkV2({
                    categoriaEvento: isCompleted ? 'mensaje migracion completada' : 'mensaje migracion',
                    accionEvento: 'vista',
                    action: 'open',
                    format: 'message',
                    component: isCompleted ? 'message/migrationCompleted' : 'message/migration',
                    element: 'full'
                });
                this.setState({ isTrackingSent: true });
            }

            return (
                <div className="col-xs-12 col-md-12">
                    <div
                        className="my-global-position-view__migration-message"
                    >
                        <OKMessage
                            key="migrationMessage"
                            closeButton
                            id="migrationMessage"
                            modifier="dark-bg"
                            onCloseButtonClick={onCloseButtonClick}
                            visible={this.state.migrationMessageVisible}
                        >
                            <FormattedText
                                value={
                                    isCompleted
                                        ? 'branchMigration-mbMigrationBannerMigrationCompleted'
                                        : 'branchMigration-mbMigrationBannerMigrateNowTitle'
                                }
                            />
                            {!isCompleted && (
                                <OKButton modifier="primary" onClick={goToMigration} >
                                    <FormattedText value="branchMigration-mbMigrationBannerMigrateNowButton" />
                                </OKButton>
                            )}
                        </OKMessage>
                    </div>
                </div>
            );
        }
    };

    render() {

        const {
            immGlobalPosition,
            immAccounts,
            immCards,
            landingBoxes,
            immLoans,
            immWalletSummarization,
            immWallets,
            immFutures,
            immFunds,
            immPlans,
            immAggregatorData,
            immScreen,
            immUserNotifications,
            immWealthRoboValues,
            immPersoneticsTeaser,
            expensesActionsOld,
            flagBasedFeatures,
            getEntitiesData,
            getGlobalPositionTink,
            getPersoneticsSubscriptionStatus,
            getSecondFactorAuth,
            isFetchingUserTechnicalInfo,
            lastAccess,
            immLastKeyChange,
            immPersoneticsSubscriptionDetails,
            immSegmentedLoanProducts,
            setProspectDisclaimerClosed,
            setProspectDisclaimerPrompt,
            isTinkAggregator,
            wealthDataFF,
            wealthErrorFF,
            isWealthDataFetching,
            isFetching,
            loanRecordStatus,
            setWaferIdRequest,
            immFlagBasedMBFeatures,
        } = this.props;
        const hasImmWealthValues = immWealthRoboValues.get('totalDiscrecionalAmount');
        const hasInvestments =
            immWallets.size || immFutures.size || immFunds.size || immPlans.size || hasImmWealthValues;
        const segmentedCards = immSegmentedLoanProducts.get('type') === CREDIT_CARD_STANDAR_TYPE
        const easyLoanInfo = this.buildEasyLoanInfo();
        const easyLoanSideAccess =
            easyLoanInfo && flagBasedFeatures.get(EASY_LOAN_WAFFER) && loanRecordStatus === false && !segmentedCards
                ? this.buildEasyLoanSideAccess(easyLoanInfo)
                : null;
        const cardsSideAccess = segmentedCards ? this.buildCardSideAccess() : null;
        let personeticsBlock;
        personeticsBlock = (
            <PersoneticsTeasersView
                immPersoneticsTeaser={immPersoneticsTeaser}
                immPersoneticsSubscriptionDetails={immPersoneticsSubscriptionDetails}
                getPersoneticsSubscriptionStatus={getPersoneticsSubscriptionStatus}
            />
        );
        const title = formatText('landingHeader-global');
        const tutorial = (
            <TutorialLauncher
                type={flagBasedFeatures.get(AGGREGATOR) ? GRAPHIC_TUTOR_TYPE_13 : GRAPHIC_TUTOR_TYPE_1}
                title={formatText('tutorials-globalPositionTitle')}
                subtitle={formatText('tutorials-globalPositionSubtitle')}
                tooltip={formatText('tutorials-globalPositionTooltip')}
            />
        );

        let settingsMobileButton;

        if (immScreen.get('isMobile')) {
            settingsMobileButton = this.buildSettingsMobileButton();
        }

        const hasNewPfmView = flagBasedFeatures.get(PFM_NEW_FEATURES);
        const disableInvestments = !flagBasedFeatures.get(INVESTMENTS) && __CONTACT_CENTER__;
        const leftColumnWidth = !disableInvestments
            ? 'col-md-8-cc-6 col-xs-12-cc-6'
            : 'col-md-12 col-xs-12';
        const leftColumnClassName = contactCenterClassName(
            'my-global-position-view__left-column',
            'my-global-position-view__header ' + leftColumnWidth
        );
        const rightColumnClassName = contactCenterClassName(
            'my-global-position-view__right-column',
            'col-md-4-cc-6 col-xs-12-cc-6'
        );
        const gridViewClassName = conditionalClassName(
            'grid-view--fix-cell-separation-bottom',
            'grid-view--variable-cell-separation',
            'col-xs-12 col-sm-6 col-md-12'
        );
        const expensesClass = classnames(
            'col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation-bottom',
            {
                'my-global-position-view__expenses':
                    !flagBasedFeatures.get(AGGREGATOR) &&
                    !flagBasedFeatures.get(CREDIT) &&
                    __CONTACT_CENTER__,
            }
        );

        changeBiocatchContext(biocatch.ACCOUNT_OVERVIEW);

        return (
            <div className="my-global-position-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="pg" customClass="col-xs-12">
                            <OKHeaderLanding
                                title={title}
                                tooltipContent={{}}
                                tutorial={tutorial}
                                inputClassName="ok-header-landing--pg"
                            >
                                <WebappRender>
                                    <LastAccess isLoading={isFetchingUserTechnicalInfo} lastAccess={lastAccess} />
                                    {settingsMobileButton}
                                </WebappRender>
                                <ContactCenterRender>
                                    <LastAccess
                                        isLoading={isFetchingUserTechnicalInfo}
                                        lastAccess={lastAccess}
                                        title={formatText('common-lastAccess')}
                                    />
                                    <LastAccess
                                        isLoading={isFetchingUserTechnicalInfo}
                                        lastAccess={immLastKeyChange.getIn(['cmcContract', 'keyChange'])}
                                        error={immLastKeyChange.get('errorReceived')}
                                        title={formatText('commons-lastKeyChange')}
                                        isLastModificationText={true}
                                    />
                                </ContactCenterRender>
                            </OKHeaderLanding>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-gp">
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <ProspectPrompt
                                    immPromptNotification={immUserNotifications.get('promptNotification')}
                                    disclaimerClosed={immUserNotifications.get('disclaimerClosed')}
                                    disclaimerPrompt={immUserNotifications.get('disclaimerPrompt')}
                                    setProspectDisclaimerClosed={setProspectDisclaimerClosed}
                                    setProspectDisclaimerPrompt={setProspectDisclaimerPrompt}
                                />
                            </div>
                            {this.buildFiscalMessage()}
                            {this.buildSCAMessage()}
                            {this.buildMigrationMessage()}
                            <div className={leftColumnClassName}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <GlobalPositionSavingsSection
                                            immCards={immCards}
                                            immAccounts={immAccounts}
                                            immGlobalPosition={immGlobalPosition}
                                            landingBoxes={landingBoxes}
                                            isBalanceDrawn
                                        />
                                    </div>
                                    <FeatureTogglingRender notAllowedProductKey={INVESTMENTS}>
                                        <div className="col-md-12  grid-view--fix-cell-separation">
                                            <GlobalPositionInvestmentsSection
                                                immWealthRoboValues={immWealthRoboValues}
                                                immWalletSummarization={immWalletSummarization}
                                                landingBoxes={landingBoxes}
                                                hasInvestments={hasInvestments}
                                                isRoboEnabled={flagBasedFeatures.get('robo-enabled')}
                                                wealthDataFF={wealthDataFF}
                                                wealthErrorFF={wealthErrorFF}
                                                isWealthDataFetching={isWealthDataFetching}
                                                isFetching={isFetching}
                                                immFlagBasedMBFeatures={immFlagBasedMBFeatures}
                                            />
                                        </div>
                                    </FeatureTogglingRender>
                                    <WebappRender>
                                        <FeatureTogglingRender notAllowedProductKey={CREDIT}>
                                            <div className="col-md-12 grid-view--fix-cell-separation">
                                                <GlobalPositionFinancialSection
                                                    immCards={immCards}
                                                    immLoans={immLoans}
                                                    easyLoanInfo={easyLoanInfo}
                                                    landingBoxes={landingBoxes}
                                                    immFlagBasedFeature={flagBasedFeatures}
                                                    setWaferIdRequest={setWaferIdRequest}
                                                    immScreen={immScreen}
                                                />
                                            </div>
                                        </FeatureTogglingRender>
                                    </WebappRender>
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        <GlobalAllPositionsSummary
                                            immCards={immCards}
                                            immAccounts={immAccounts}
                                            immSavings={immGlobalPosition.get('savings')}
                                            immWalletSummarization={immWalletSummarization}
                                            immWealthRoboValues={immWealthRoboValues}
                                            immLoans={immLoans}
                                            wealthDataFF={wealthDataFF}
                                            isNewPgWealthAllowed={flagBasedFeatures.get(NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES)}
                                            isBalanceDrawn
                                        />
                                    </div>
                                    <FeatureTogglingRender notAllowedProductKey={AGGREGATOR}>
                                        {isAggregatorEnabled(flagBasedFeatures) && (
                                            <div className="col-md-12 grid-view--fix-cell-separation">
                                                <WebappRender>
                                                    <AggregatorResume
                                                        flagBasedFeatures={flagBasedFeatures}
                                                        isTinkAggregator={isTinkAggregator}
                                                        retryAction={() =>
                                                            isTinkAggregator
                                                                ? getGlobalPositionTink()
                                                                : getEntitiesData(false, 0, true)
                                                        }
                                                        immAggregatorData={immAggregatorData}
                                                        getSecondFactorAuth={getSecondFactorAuth}
                                                    />
                                                </WebappRender>
                                            </div>
                                        )}
                                    </FeatureTogglingRender>
                                    <FeatureTogglingRender notAllowedProductKey={AGGREGATOR}>
                                        {isAggregatorEnabled(flagBasedFeatures) && (
                                            <div className="col-md-12 grid-view--fix-cell-separation">
                                                <WebappRender>
                                                    <AggregatorSummary
                                                        immAggregatorData={immAggregatorData}
                                                        immCards={immCards}
                                                        immAccounts={immAccounts}
                                                        immGlobalPosition={immGlobalPosition}
                                                        immWealthRoboValues={immWealthRoboValues}
                                                        landingBoxes={landingBoxes}
                                                        immWalletSummarization={immWalletSummarization}
                                                        hasInvestments={hasInvestments}
                                                        immLoans={immLoans}
                                                        isBalanceDrawn
                                                    />
                                                </WebappRender>
                                            </div>
                                        )}
                                    </FeatureTogglingRender>
                                </div>
                            </div>
                            {!disableInvestments && (
                                <div className={rightColumnClassName}>
                                    <div className="row">
                                        {cardsSideAccess}
                                        {easyLoanSideAccess}
                                        <ContactCenterRender>
                                            <FeatureTogglingRender notAllowedProductKey={CREDIT}>
                                                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                                                    <GlobalPositionFinancialSection
                                                        immCards={immCards}
                                                        immLoans={immLoans}
                                                        landingBoxes={landingBoxes}
                                                        immFlagBasedFeature={flagBasedFeatures}
                                                        setWaferIdRequest={setWaferIdRequest}
                                                    />
                                                </div>
                                            </FeatureTogglingRender>
                                        </ContactCenterRender>
                                        <FeatureTogglingRender notAllowedProductKey={AGGREGATOR}>
                                            {isAggregatorEnabled(flagBasedFeatures) && (
                                                <div className={gridViewClassName}>
                                                    <WebappRender>
                                                        <AggregatorCommercialAdd
                                                            showGlobalPositionButton={
                                                                immAggregatorData.getIn(['data', 'banks'], { size: 0 }).size
                                                            }
                                                        />
                                                    </WebappRender>
                                                </div>
                                            )}
                                        </FeatureTogglingRender>
                                        {personeticsBlock}
                                        <FeatureTogglingRender notAllowedProductKey={PFM}>
                                            <div className={expensesClass}>
                                                {hasNewPfmView ? (
                                                    <ExpensesSummaryBox immAccounts={immAccounts} />
                                                ) : (
                                                    <GlobalPositionExpenses
                                                        immExpenses={immGlobalPosition.get('expenses')}
                                                        actions={expensesActionsOld}
                                                    />
                                                )}
                                            </div>
                                        </FeatureTogglingRender>
                                        <div className="col-xs-12 col-sm-6 col-md-12">
                                            <ECommerceKeyBanner />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation-bottom">
                                            <CallMeBack pageTitle={title} hasEntrance={false} />
                                        </div>
                                        <div className="col-xs-12 grid-view--fix-cell-separation-bottom">
                                            <CommercialAds path="global" type="banner-a" />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <WebappRender>
                    <div className="container-fluid grid-view__cross-selling">
                        <div className="row">
                            <CommercialAds path="global" type="cross-selling" />
                        </div>
                    </div>
                </WebappRender>
            </div>
        );
    }
}

MyGlobalPositionView.propTypes = {
    boxToggle: PropTypes.func,
    clientName: PropTypes.string.isRequired,
    expensesActionsOld: PropTypes.object,
    fatcaCloseModal: PropTypes.func,
    fatcaDocumentation: PropTypes.object.isRequired,
    fatcaOpenModal: PropTypes.func,
    fiocDocumentation: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object,
    getEntitiesData: PropTypes.func,
    getPersoneticsSubscriptionStatus: PropTypes.func,
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immAggregatorData: PropTypes.object,
    immCards: PropTypes.object,
    immEasyLoan: PropTypes.object,
    immEasyLoanTypeC: PropTypes.object,
    immFunds: PropTypes.object,
    immFutures: PropTypes.object,
    immGlobalPosition: PropTypes.object,
    immInterstitials: PropTypes.object,
    immLastKeyChange: PropTypes.object,
    immLoans: PropTypes.object,
    immMortgages: PropTypes.object,
    immPersoneticsTeaser: PropTypes.object.isRequired,
    immPlans: PropTypes.object,
    immScreen: PropTypes.object.isRequired,
    immSegmentedLoanProducts: PropTypes.object,
    immUserNotifications: PropTypes.object,
    immWallets: PropTypes.object,
    immWalletSummarization: PropTypes.object,
    immWealthRoboValues: PropTypes.object,
    isFetchingUserTechnicalInfo: PropTypes.bool,
    landingBoxes: PropTypes.object,
    lastAccess: PropTypes.string,
    location: PropTypes.object,
    immPersoneticsSubscriptionDetails: PropTypes.object,
    requestAccessKeyData: PropTypes.func,
    requestPublicInformation: PropTypes.func,
    setProspectDisclaimerClosed: PropTypes.func.isRequired,
    setProspectDisclaimerPrompt: PropTypes.func.isRequired,
    getSecondFactorAuth: PropTypes.func,
    immFlagBasedFeatures: PropTypes.object,
    isTinkAggregator: PropTypes.bool,
    getGlobalPositionTink: PropTypes.func,
    customerId: PropTypes.string,
    wealthDataFF: PropTypes.object,
    wealthErrorFF: PropTypes.bool,
    isWealthDataFetching: PropTypes.bool,
    isFetching: PropTypes.bool,
    loanRecordStatus: PropTypes.bool,
    setWaferIdRequest: PropTypes.func,
    immPayrollLoanRecordStatus: PropTypes.object.isRequired,
};

module.exports.constructor = MyGlobalPositionView;
module.exports.MyGlobalPositionView = connect(
    state => {
        const isTinkAggregator = state.flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR)
        return {
            customerId: state.profile.get('customerId', ''),
            loanRecordStatus: state.loanRecordStatus.get('error'),
            clientName: state.profile.get('nombreCliente', ''),
            fatcaDocumentation: state.fatcaDocumentation,
            fiocDocumentation: state.fiocDocumentation,
            flagBasedFeatures: state.flagBasedFeatures,
            immAccounts: state.accounts,
            immAggregatorData: state.aggregatorData,
            immCards: state.cards,
            immEasyLoan: state.contractEasyLoan,
            immEasyLoanTypeC: state.contractEasyLoanTypeC,
            immFunds: state.brokerWallets.get('fundsList'),
            immFutures: state.brokerWallets.get('futuresList'),
            immGlobalPosition: state.globalPosition,
            immInterstitials: state.interstitials,
            immLastKeyChange: state.accessKeyChange,
            immLoans: state.loans,
            immMigration: state.migration,
            immPersoneticsSubscriptionDetails: state.personeticsSubscription,
            immPersoneticsTeaser: state.personeticsTeaser,
            immPlans: state.brokerWallets.get('plansList'),
            immProfile: state.profile,
            immScreen: state.screen,
            immSegmentedLoanProducts: state.segmentedLoanProducts,
            immUserNotifications: state.userNotifications,
            immWallets: state.brokerWallets.get('walletList'),
            immWalletSummarization: state.brokerWallets.get('walletSummarization'),
            immWealthRoboValues: state.brokerWallets.get('wealthRoboValues'),
            isFetchingUserTechnicalInfo: state.accessKeyChange.get('isFetching'),
            landingBoxes: state.landings.get('expandedBoxes').get('pg'),
            lastAccess: state.accessKeyChange.getIn(['cmcContract', 'lastAccess']),
            isTinkAggregator,
            wealthDataFF: state.globalPosition.get('wealthDataFF'),
            wealthErrorFF: state.globalPosition.get('wealthErrorFF'),
            isWealthDataFetching: state.globalPosition.get('isWealthDataFetching'),
            isFetching: state.globalPosition.get('isFetching'),
            immPayrollLoanRecordStatus: state.loanRecordStatus,
            immFlagBasedMBFeatures: state.flagBasedMBFeatures,
        };
    },
    dispatch => ({
        getGlobalPositionTink: bindActionCreators(getGlobalPositionTink, dispatch),
        fatcaOpenModal: bindActionCreators(fatcaDocumentarionActions.fatcaOpenModal, dispatch),
        fatcaCloseModal: bindActionCreators(fatcaDocumentarionActions.fatcaCloseModal, dispatch),
        getEntitiesData: bindActionCreators(aggregatorDataActions.getEntitiesData, dispatch),
        getPersoneticsSubscriptionStatus: bindActionCreators(
            personeticsSubscriptionActions.getPersoneticsSubscriptionStatus,
            dispatch
        ),
        getSecondFactorAuth: bindActionCreators(aggregatorDataActions.getSecondFactorAuth, dispatch),
        expensesActionsOld: bindActionCreators(expensesActionsOld, dispatch),
        getSegmentedLoanProducts: bindActionCreators(
            okLoanActions.segmentedLoanProducts.getSegmentedLoanProducts,
            dispatch
        ),
        requestPublicInformation: bindActionCreators(requestPublicInformation, dispatch),
        requestAccessKeyData: bindActionCreators(accessKeyChangeActions.requestAccessKeyData, dispatch),
        setProspectDisclaimerClosed: bindActionCreators(
            userNotificationsActions.setProspectDisclaimerClosed,
            dispatch
        ),
        setProspectDisclaimerPrompt: bindActionCreators(
            userNotificationsActions.setProspectDisclaimerPrompt,
            dispatch
        ),
        setWaferIdRequest: bindActionCreators(
            setWaferIdRequest,
            dispatch
        ),
    })
)(withFeatureToggling(withRouter(MyGlobalPositionView)));
